/* ============================================================
   BYG Footer 3D-Zeichen am Scroll (PRÜFSTAND, Phase 11)

   R13/P19 — Manuel: "Beim 3D-Modell-Logo moechte ich, dass das auch
   ein 3D-Modell ist und sich beim Scrollen bewegt, so wie oben, nur
   etwas kleiner."

   WARUM NICHT byg-hero-logo.js WIEDERVERWENDEN. Das Hero-Skript haengt
   an genau einem [data-byg-hero-logo] und leitet seinen Fortschritt aus
   dem Scrollstand AB SEITENANFANG ab (y / (0.62 x Viewporthoehe)). Fuer
   ein Zeichen, das weit unten in der Seite steht, waere das immer 1 —
   das Zeichen stuende von der ersten Sekunde an auf dem letzten Frame.
   Hier wird der Fortschritt deshalb aus der Lage des ELEMENTS im
   Sichtfenster gerechnet.

   WAS AUS DEM HERO-SKRIPT UEBERNOMMEN IST, weil es dort richtig gelöst
   ist und hier dieselben Fallen stehen:
     - clearRect VOR jedem drawImage. Die Frames tragen einen
       Alphakanal; ohne Loeschen stapeln sich alle bisher gezeichneten
       Drehstufen uebereinander und das Zeichen wird zu Matsch.
     - devicePixelRatio, gedeckelt auf 2. Ohne das ist die Zeichnung auf
       jedem modernen Bildschirm unscharf; ueber 2 kostet es nur noch
       Speicher.
     - Laden in Stufen statt alles sofort.
     - Das Poster steht, bis wirklich ein Frame gemalt ist. Genau hier
       ist der Platzhalter im Hero einmal durchgerutscht.
     - frameLooksWrong(): Shopifys no-image-Platzhalter kommt mit
       HTTP 200 und feuert onload. Geprueft wird deshalb das Ergebnis.

   ---------- DAS SEITENGEWICHT, GEMESSEN ----------
   Die Briefing-Annahme "160 Bilder, je rund 35-39 KB" stimmt nicht.
   Am CDN nachgemessen: die Frames sind 1560x1560 und 398-446 KB gross
   (byg-intro-000.webp = 409.186 Bytes). Jedes achte Bild in
   Originalgroesse waere also nicht 740 KB, sondern 8,2 MB — fuer ein
   Zeichen, das hier maximal 104 Bildpunkte hoch dargestellt wird.
   Das CDN liefert aber skalierte Fassungen desselben Assets, wenn man
   _<n>x<n> vor die Endung setzt. Nachgemessen, mit und ohne ?v=:
     byg-intro-000_160x160.webp = 13.451 B
     byg-intro-000_240x240.webp = 22.883 B
     byg-intro-000_320x320.webp = 35.331 B
   Alle drei kommen in der angeforderten Groesse.

   WELCHE FASSUNG GEBRAUCHT WIRD — nachgerechnet, und zwar anders als
   zuerst notiert. Nicht die Hoehe ist das Mass, sondern die BREITE der
   Zeichenflaeche geteilt durch den Ausschnitt: das Standbild ist
   700x561, die Box also 1,2478-mal so breit wie hoch, bei
   height: clamp(66px,7vw,104px) im groessten Fall 130 Bildpunkte
   breit. Der Ausschnitt nutzt davon nur CROP_W = 76,66 % der
   Framebreite, der Frame muss also entsprechend groesser sein:
   130 x devicePixelRatio 2 = 260, geteilt durch 0,7666 = 339
   Bildpunkte Framekante. Die frueher hier notierten 208 Bildpunkte
   liessen den Ausschnitt weg und waren zu klein gerechnet.
   Daraus folgt, was variante() wirklich waehlt:
     devicePixelRatio 2: ab rund 1053 px Fensterbreite die 320er,
                         darunter die 240er
     devicePixelRatio 1: ab rund 1404 px die 240er, darunter die 160er
   DIE BYTES, alle 20 Frames einzeln nachgemessen, mit dem ?v= aus der
   Vorschau — dasselbe CDN liefert je nach Accept-Header verschiedene
   Formate, und das aendert die Zahl um den Faktor 3,7:
     Browser (AVIF/WebP): 160er  90 KB · 240er 126 KB · 320er 194 KB
     ohne beides (PNG):   160er 260 KB · 240er 468 KB · 320er 718 KB
   Die PNG-Spalte ist die Obergrenze, nicht der Alltag. Geladen wird
   das erst, wenn der Fuss ins Bild kommt, und in zwei Stufen (erst
   jedes 16., dann jedes 8.).

   KEIN CACHE-GEWINN AUS DEM HERO, und das ist eine bewusste
   Entscheidung. Geprueft: byg-hero-logo.js holt mit FIRST_STEP = 8 ueber
   buildOrder() genau die Vielfachen von 8 plus den Frame 159 — also
   GENAU die Bilder, die hier bei data-step 8 gebraucht werden. (Die
   REIHENFOLGE ist dort seit Runde 15 bisektiv: 0, 80, 40, 120, 16, 56 …,
   und 159 kommt erst nach der groben Stufe. Die MENGE ist dieselbe
   geblieben, und nur auf die kommt es fuer den Cache an.)
   In Originalgroesse waeren sie beim
   Erreichen des Fusses auf der Startseite tatsaechlich schon im Cache
   und gratis. Aber: der Fuss steht auf JEDER Seite, die Hero-Section
   nur auf der Startseite. Auf jeder Unterseite waere der Preis dann
   8,2 MB statt der 126 bis 194 KB von oben. Zweihundert Kilobyte immer
   ist besser als null manchmal und 8,2 MB sonst.

   OHNE JS, BEI "BEWEGUNG REDUZIEREN" und solange der erste Frame nicht
   steht, bleibt das heutige Standbild byg-logo-3d.png stehen — die
   Zeichenflaeche ist bis dahin unsichtbar (byg-footer.css) und es wird
   kein einziges Bild geladen. Der Ruhezustand ist der fertige, nie der
   leere.

   ---------- WAS RUNDE 15 HIER GEAENDERT HAT ----------
   Die Zahlen oben gelten unveraendert, weil data-step bei 8 geblieben ist
   (dazu unten). Dazugekommen sind, in der Reihenfolge ihrer Wirkung:
     F7  Die Dauerschleife ist weg. tick() kettete sich, solange der Fuss
         im Bild war, und fortschritt() las dabei in JEDEM Bild das Layout.
         Jetzt laeuft die Schleife nur bei Bewegung, und alle
         Layout-Lesezugriffe sind aus fortschritt() heraus.
     F8  verfeinern() haengt am Scrollen statt an der Sichtbarkeit. Erst
         damit stimmt die Zusage "erst jedes 16., dann jedes 8." — vorher
         kam Stufe 2 immer, der Fuss kostete also auf JEDER Seite die
         vollen 126 bis 194 KB statt der Haelfte.
     F5  Zeitbasierte Glaettung, die es hier vorher gar nicht gab: zeichne()
         folgte fortschritt() direkt und war bei Trackpad-Spruengen hart.
         Dieselbe Zeitkonstante wie im Hero.
     F1  img.decode() vor dem Eintragen — die Dekodierung wandert aus dem
         Scroll-Frame in die Ladephase.
     F2  Vorskalieren, wenn es sich rechnet (greift als Netz, wenn das CDN
         die kleinen Fassungen nicht liefert).
     F9  Die Farbkorrektur auf der Zeichenflaeche (byg-footer.css). Sie hat
         hier gefehlt, der Farbton sprang bei is-live um 18,6 Grad.
     F3  Die Ueberblendung ist eingebaut, bleibt bei step 8 aber ohne
         Wirkung (18 Grad Abstand) — Begruendung bei CROP_* und in
         zeichne().
   KORRIGIERT NACH DER DURCHSICHT: data-step 4 ist zurueckgenommen (siehe
   CROP_*, die Messbasis fehlte), und das Vorskalieren laeuft nicht mehr in
   derselben Schleife wie das Dekodieren, sondern gedeckelt in eigenen
   Zeitschlitzen (siehe nachPumpe()).

   Kein jQuery, keine Libraries (Leitplanken §4).
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Der Zeichen-Ausschnitt, gemessen ----------
     Die Frames sind 1560x1560, das Zeichen fuellt sie nicht aus. Ueber
     alle 20 benutzten Frames gemessen liegt die Vereinigung aller
     Silhouetten bei 11,67 % bis 88,33 % waagrecht und 19,58 % bis
     80,42 % senkrecht — symmetrisch zur Mitte, und zwar genau deshalb,
     weil sich das Zeichen um seine Mitte dreht.
     Mit diesem Ausschnitt hat die Zeichnung das Seitenverhaeltnis
     1,260; das Standbild byg-logo-3d.png hat 1,257 (700x561). 0,2 %
     Unterschied — deshalb passt die Bildfolge in dieselbe Box wie das
     Standbild, ohne Sprung und ohne Layoutverschiebung.
     Ein grosszuegigerer Ausschnitt waere sicherer gegen Abschneiden,
     wuerde das Zeichen aber kleiner machen als heute — und kleiner ist
     das Gegenteil dessen, was Manuel wollte.

     DESHALB HAENGT DIESER AUSSCHNITT AN data-step="8", und das ist keine
     Formalitaet: die Messbasis sind GENAU die 20 Frames, die bei step 8
     gemalt werden (0, 8 … 152). Wer step verkleinert, malt Frames, deren
     Silhouette hier nie gemessen wurde, und malenAus() schneidet ohne
     Reserve (c.drawImage(img, q.x, q.y, q.w, q.h, …)). Liegt eine dieser
     Silhouetten weiter aussen, wird das Zeichen bei jedem zweiten Frame
     am Rand beschnitten — als Flackern waehrend der Drehung, und die
     Ursache sieht man dem Code nicht an.
     WER step AENDERN WILL, misst vorher nach: die Vereinigung aller
     Silhouetten ueber die dann benutzte Framemenge bestimmen und CROP_*
     danach setzen (oder, wenn das Zeichen nicht kleiner werden darf, mit
     1-2 Prozentpunkten Reserve und dem Wissen, dass es dadurch um
     ebensoviel kleiner wird). In Runde 15 ist genau dieser Schritt
     uebersprungen worden; step 4 ist deshalb zurueckgenommen. */
  var CROP_X = 0.1167;
  var CROP_Y = 0.1958;
  var CROP_W = 0.7666;
  var CROP_H = 0.6084;

  /* Eine Basis-URL ist nur brauchbar, wenn sich die Frame-Nummer darin
     ersetzen laesst — dieselbe Pruefung wie im Hero-Skript. */
  var FRAME_RE = /-000(?=[._])/;

  function reducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  /* ---------- R15/P7: dieselben Zahlen wie oben ----------
     Die Werte stehen bewusst doppelt (hier und in byg-hero-logo.js) und
     nicht in einer gemeinsamen Datei: beide Skripte laufen allein, der
     Fuss auf JEDER Seite, der Hero nur auf der Startseite. Wichtig ist,
     dass sie GLEICH sind — "auch oben" heisst in der Umkehrung: oben und
     unten muessen sich gleich anfuehlen. Herleitung aller Zahlen im Kopf
     von assets/byg-hero-logo.js, Abschnitte (1), (2) und (7). */
  var TAU = 70;        /* Zeitkonstante der Glaettung in ms */
  var MAX_DT = 64;     /* Deckel fuer einen ausgefallenen Frame, in ms */
  var BLEND_MAX = 4;   /* Hoechstabstand in FRAMES, bis zu dem ueberblendet wird (= 9 Grad) */
  var ENDE = 0.02;     /* Schluss der Glaettung in FRAMES (= 0,045 Grad) */
  var DECODE_CAP = 2;  /* hoechstens zwei Dekodierungen gleichzeitig */
  var PRESCALE_RATIO = 0.60;

  function initOne(root) {
    if (root.dataset.bygFooterLogo === '1') return;
    root.dataset.bygFooterLogo = '1';

    var canvas = root.querySelector('canvas');
    var poster = root.querySelector('[data-byg-footer-logo-poster]');
    if (!canvas || !canvas.getContext) return;

    /* Bewegung reduziert: Standbild stehen lassen, nichts laden.
       Das ist die Stelle, an der die Leitplanke zaehlt — abgeschaltet
       wird die Bewegung, nicht das Bild. Der Ausstieg bleibt VOR dem
       ersten Byte und damit auch vor jeder Vorskalierung. */
    if (reducedMotion()) return;

    var base = root.getAttribute('data-base') || '';
    if (!FRAME_RE.test(base)) return; /* unbrauchbare Basis: Poster bleibt */

    var total = parseInt(root.getAttribute('data-frames'), 10);
    if (!(total > 1)) total = 160;
    var step = parseInt(root.getAttribute('data-step'), 10);
    if (!(step >= 1)) step = 8;

    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    /* ---------- Welche Frames ----------
       0, step, 2·step … solange es unter total bleibt. Bei step 8 und
       160 Frames sind das 0, 8 … 152 = 20 Stueck. Der letzte Frame
       (159) kommt bewusst NICHT dazu: 159 und 152 liegen sieben Frames
       auseinander, 159 und 0 nur einen — die Drehung ist ein voller
       Umlauf, der letzte Frame ist also fast wieder der erste und
       waere ein bezahltes Duplikat.
       R15/P7: step stand in dieser Runde kurzzeitig auf 4 (40 Stellungen,
       9 statt 18 Grad) und ist nach der Durchsicht wieder 8. Grund: der
       Zuschnitt CROP_* unten ist ueber genau diese 20 Frames GEMESSEN und
       hat keine Reserve; die 20 Zwischenframes der Stufung 4 waren in der
       Messung nie enthalten und koennten am Zuschnittrand anschneiden.
       Ausfuehrlich in sections/byg-footer.liquid. Die Ueberblendung in
       zeichne() bleibt eingebaut und schaltet sich bei step 4 von selbst
       ein, sobald die Messung vorliegt — hier ist nichts weiter zu tun,
       als das Datenattribut zu aendern. */
    var idxs = [];
    for (var i = 0; i < total; i += step) idxs.push(i);
    var n = idxs.length;

    /* frames[k]   die MALQUELLE: das Image oder eine vorskalierte Flaeche
       quellen[k]  immer das Image, damit nach einem Groessenwechsel neu
                   vorskaliert werden kann, ohne neu zu laden
       skaliert[k] true, wenn frames[k] eine vorskalierte Flaeche ist */
    var frames = new Array(n);
    var quellen = new Array(n);
    var skaliert = new Array(n);

    /* Zwei Nachschlagetabellen statt der Suchschleife
       naechsterGeladener(), die bei jedem Bild bis zu n Schritte lief.
       vorh[k] = groesster geladener Platz <= k, nach[k] = kleinster >= k. */
    var vorh = new Array(n);
    var nach = new Array(n);
    function tabellen() {
      var k, letzt = -1;
      for (k = 0; k < n; k++) { if (frames[k]) letzt = k; vorh[k] = letzt; }
      letzt = -1;
      for (k = n - 1; k >= 0; k--) { if (frames[k]) letzt = k; nach[k] = letzt; }
    }
    tabellen();

    /* ---------- Die Groesse der nachgeladenen Fassung ----------
       Gebraucht wird die Kantenlaenge in Geraetepunkten. Der Ausschnitt
       nimmt nur CROP_W der Framebreite ein, also braucht der Frame
       entsprechend mehr. */
    function variante() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var breit = (canvas.clientWidth || root.clientWidth || 130) * dpr;
      var brauch = breit / CROP_W;
      /* Im groessten Fall (130 Bildpunkte Box, dpr 2) sind das 339 —
         also die 320er. Die Alternative waere die 240er mit 1,41-facher
         Hochskalierung, und die sieht man. Siehe Kopf. */
      return brauch <= 160 ? 160 : (brauch <= 240 ? 240 : 320);
    }
    /* Wird erst in starten() gesetzt, nicht hier: zur Initialisierung
       kann das Standbild noch nicht geladen sein (loading="lazy") und
       die Box damit 0 breit — dann waehlte variante() die kleinste
       Fassung fuer einen Bildschirm, der die groesste braucht. Nach dem
       ersten Sichtbarwerden steht das Layout. */
    var groesse = 240;

    function urlFor(idx, klein) {
      var num = ('00' + idx).slice(-3);
      var u = base.replace(FRAME_RE, '-' + num);
      if (!klein) return u;
      /* _<n>x<n> vor die Endung, ?v= bleibt unangetastet dahinter. */
      return u.replace(/(-\d{3})(\.[a-z0-9]+)/i, '$1_' + groesse + 'x' + groesse + '$2');
    }

    /* Shopifys no-image-Platzhalter kommt mit HTTP 200 und feuert
       onload. Geprueft wird deshalb das Ergebnis, nicht der Status —
       uebernommen aus byg-hero-logo.js. */
    function frameLooksWrong(img, url) {
      if (!img.naturalWidth || !img.naturalHeight) return true;
      if (url.indexOf('no-image') !== -1) return true;
      var r = img.naturalWidth / img.naturalHeight;
      return r < 0.94 || r > 1.06;
    }

    /* ---------- Laden in zwei Stufen ----------
       Stufe 1 ist jeder zweite Eintrag der Liste (bei step 8 also jedes
       16. Bild, 10 Stueck = gemessene 63 KB in der 240er bzw. 97 KB in der
       320er Fassung). Erst wenn die durch ist UND wirklich gescrollt wird,
       kommt Stufe 2 dazu und bringt es auf die 20 Bilder, also auf die
       126 bzw. 194 KB, die der Fuss schon vor Runde 15 gekostet hat. Wer
       am Fuss ankommt und stehen bleibt, zahlt jetzt die HAELFTE davon.
       R15/P7, F8 — UND JETZT STIMMT DAS AUCH. verfeinern() hing an
       tick(), und tick() lief bei blosser SICHTBARKEIT; Stufe 2 startete
       also wenige Bilder nach dem Sichtwerden, ohne jedes Scrollen. Der
       Satz oben war damit falsch und der Fuss hat immer die volle Menge
       gekostet. verfeinern() haengt nun am scroll-Ereignis, so wie im
       Hero — damit ist die Mechanik in beiden Dateien dieselbe und in
       beiden richtig beschrieben. */
    var warteschlange = [];
    var gesehen = {};
    var cursor = 0;
    var inFlight = 0;
    var stufe = 0;
    var schlecht = 0;
    var kleinOk = true;

    function einreihen(s) {
      for (var k = 0; k < n; k += s) {
        if (!gesehen[k]) { gesehen[k] = 1; warteschlange.push(k); }
      }
    }

    function pumpe() {
      while (inFlight < 3 && cursor < warteschlange.length) ladeNaechsten();
    }

    function ladeNaechsten() {
      var k = warteschlange[cursor++];
      var img = new Image();
      var klein = kleinOk;
      var src = urlFor(idxs[k], klein);
      /* KEIN img.decoding = 'async': das Attribut gilt nur fuer Bilder IM
         DOKUMENT, die der Browser sonst synchron dekodieren wuerde, um
         einen leeren Platz zu vermeiden. Dieses Bild steht nie im
         Dokument — gebraucht wird es von drawImage, und drawImage braucht
         die Pixel sofort. Dekodiert wird deshalb ausdruecklich ueber
         img.decode(), siehe stufePumpe(). */
      inFlight++;

      function fertig() { inFlight--; pumpe(); }

      img.onload = function () {
        if (frameLooksWrong(img, src)) {
          if (klein) {
            /* Die skalierte Fassung taugt nicht — ab jetzt Originale.
               Dasselbe img laedt weiter, bleibt also in der Luft.
               WICHTIG fuer die Reihenfolge: img.decode() darf erst NACH
               dieser Pruefung angestossen werden, weil eine Zusage
               abgelehnt wird, sobald danach img.src neu gesetzt wird. */
            klein = false;
            kleinOk = false;
            src = urlFor(idxs[k], false);
            img.src = src;
            return;
          }
          schlecht++;
          /* Vier unbrauchbare Originale: die Quelle taugt nicht.
             Abbrechen und das Standbild stehen lassen. Bewusst ohne
             pumpe(): hier SOLL der Ladebetrieb enden. */
          if (schlecht > 3) { cursor = warteschlange.length; inFlight--; return; }
          fertig();
          return;
        }
        stufeEinreihen(k, img);
        fertig();
      };
      img.onerror = function () {
        if (klein) {
          klein = false;
          kleinOk = false;
          src = urlFor(idxs[k], false);
          img.src = src;
          return;
        }
        fertig();
      };
      img.src = src;
    }

    function verfeinern() {
      /* Dieselbe Sicherung wie im Hero: die Notbremse setzt cursor an das
         Ende der Warteschlange, und genau das ist die Bedingung dafuer,
         Stufe 2 anzuhaengen. Vier unbrauchbare Originale heissen: nicht
         weitermachen. */
      if (schlecht > 3) return;
      if (stufe !== 1) return;
      if (cursor < warteschlange.length) return; /* Stufe 1 noch unterwegs */
      stufe = 2;
      einreihen(1);
      pumpe();
    }

    /* ---------- Zwischenstufe: dekodieren, dann vorskalieren ----------
       Netz und Hauptthread sind zwei getrennte Leitungen: das geladene
       Bild gibt seinen Ladeplatz sofort frei und wartet hier. Erst nach
       der Dekodierung gilt der Frame als da — ein undekodierter Frame
       wuerde beim ersten drawImage dekodieren, also mitten im
       Scroll-Frame, und genau das soll weg.
       Hoechstens DECODE_CAP gleichzeitig: drei parallele Dekodierungen
       wuerden das Ruckeln nur in die Ladephase verlegen.

       R15/P7 KORREKTUR NACH DER DURCHSICHT — DEKODIEREN UND VORSKALIEREN
       SIND ZWEI GETRENNTE SCHLANGEN, genau wie im Hero, und aus denselben
       zwei Gruenden:
       (1) In EINER Schleife bremste sich nur der Dekodierzweig selbst
           (decodeBusy steigt, die Bedingung greift). War stufeListe leer
           und decodeBusy 0, wurde die Nacharbeit nach einem
           Groessenwechsel in einem synchronen Block erledigt — gerufen aus
           flaecheStimmt(), also aus zeichne(), also aus der rAF-Schleife.
       (2) uebernehmen() hat selbst vorskaliert und haengt an der
           decode()-Zusage. Loesen die Zusagen schnell hintereinander aus,
           sind die Rueckrufe Mikrotasks im selben Durchgang — dann landen
           alle Vorskalierungen in einer Aufgabe, und zwar in der
           Ladephase.
       WIEVIEL DAS HIER IST: vorskaliert wird nur, wenn das CDN die kleinen
       Fassungen NICHT liefert (kleinOk faellt auf false, die Quellen sind
       dann 1560er Originale). Dann sind es bei step 8 zwanzig
       drawImage-Durchgaenge von einem 1196x949 grossen Ausschnitt auf
       260x208 — der steilste Resample im Theme, zwanzigmal hintereinander.
       Kleiner als im Hero, aber derselbe Fehler, und die Mechanik soll in
       beiden Dateien dieselbe sein.
       JETZT: stufePumpe() dekodiert (begrenzt ueber DECODE_CAP wie
       bisher), uebernehmen() traegt nur ein, und nachPumpe() skaliert
       hoechstens SCALE_BURST Flaechen je ECHTEM Zeitschlitz vor. Bis eine
       Flaeche fertig ist, wird aus der Quelle gezeichnet — sichtbar ist
       das nicht (die Farbkorrektur sitzt im CSS, nicht in der Flaeche),
       nur teurer. */
    var decodeBusy = 0;
    var stufeListe = [];
    var nachskalieren = [];
    /* Zwei je Zeitschlitz, dieselbe Zahl wie DECODE_CAP: beides sind
       Arbeiten, von denen zwei in ein 16,7-ms-Budget passen muessen. */
    var SCALE_BURST = 2;
    var nachGeplant = false;

    function stufeEinreihen(k, img) {
      stufeListe.push({ k: k, img: img });
      stufePumpe();
    }
    function stufePumpe() {
      while (decodeBusy < DECODE_CAP && stufeListe.length) auftrag(stufeListe.shift());
    }
    function auftrag(job) {
      var img = job.img;
      if (typeof img.decode !== 'function') { uebernehmen(job.k, img); return; }
      decodeBusy++;
      /* Erfolg und Ablehnung fuehren in DENSELBEN Weg: ein spaet
         dekodierter Frame ist besser als ein fehlender. */
      img.decode().then(function () {
        decodeBusy--;
        uebernehmen(job.k, img);
        stufePumpe();
      }, function () {
        decodeBusy--;
        uebernehmen(job.k, img);
        stufePumpe();
      });
    }

    /* Bewusst ein Zeitschlitz und kein rAF: in einem Hintergrund-Tab
       laeuft rAF nicht, fertig werden soll es trotzdem. Die Frist von
       200 ms verhindert, dass die Arbeit auf einer dauerbeschaeftigten
       Seite liegen bleibt. */
    function nachPlanen() {
      if (nachGeplant || !nachskalieren.length) return;
      nachGeplant = true;
      var weiter = function () {
        nachGeplant = false;
        nachPumpe();
      };
      if ('requestIdleCallback' in window) {
        requestIdleCallback(weiter, { timeout: 200 });
      } else {
        window.setTimeout(weiter, 32);
      }
    }
    function nachPumpe() {
      var z = 0;
      while (z < SCALE_BURST && nachskalieren.length) {
        var k = nachskalieren.shift();
        /* Eintraege ohne Arbeit (kein Quellbild, schon vorskaliert, oder
           Vorskalieren lohnt sich nicht) kosten nur den Schleifendurchgang
           und zaehlen nicht mit. */
        if (quellen[k] && !skaliert[k] && nachtragen(k, quellen[k])) z++;
      }
      nachPlanen();
    }

    /* Der Zuschnitt und die Einpassung. Wird fuer das Vorskalieren UND
       fuer den direkten Weg gebraucht, damit beide garantiert dasselbe
       Bild ergeben.
       contain, nicht cover: abgeschnitten wird nichts. Der Ausschnitt
       ist 1,260 breit zu hoch, die Box 1,248 — die Zeichnung bleibt also
       rund 1 % unter der Boxhoehe, und das ist bei 104 Bildpunkten ein
       Bildpunkt. Waagrecht links ausgerichtet wie das Standbild
       (object-position: left center), senkrecht mittig. */
    function zuschnitt(img) {
      var iw = img.naturalWidth || img.width;
      var ih = img.naturalHeight || img.height;
      return {
        x: iw * CROP_X, y: ih * CROP_Y,
        w: iw * CROP_W, h: ih * CROP_H
      };
    }
    function malenAus(c, img, cw, ch) {
      var q = zuschnitt(img);
      if (!(q.w > 0) || !(q.h > 0)) return false;
      var s = Math.min(cw / q.w, ch / q.h);
      var dw = q.w * s, dh = q.h * s;
      c.drawImage(img, q.x, q.y, q.w, q.h, 0, (ch - dh) / 2, dw, dh);
      return true;
    }

    /* Vorskalieren, wenn es sich rechnet — dieselbe Regel wie im Hero:
       nur, wenn die Zielflaeche unter 60 % der QUELLFLAECHE (also des
       Ausschnitts) liegt. Nachgerechnet bei einer 130x104-Box, dpr 2,
       also 260x208 = 54.080 Zielpixel:
         320er Fassung: Ausschnitt 245x195 = 47.760 Pixel. 54.080 ist
           MEHR als das, es wird also leicht hochskaliert (1,06) — hier
           ist nichts zu holen, es wird nicht vorskaliert.
         1560er Original: Ausschnitt 1196x949 = 1.134.000 Pixel. 54.080
           sind 4,8 % davon — der steilste Resample im ganzen Theme, und
           zwar bei JEDEM gemalten Bild. Hier wird vorskaliert.
       Der zweite Fall tritt ein, wenn das CDN die kleinen Fassungen
       nicht liefert (kleinOk faellt auf false). Genau dafuer steht der
       Weg hier: er ist das Netz unter variante(), nicht ihr Ersatz.
       20 Flaechen von 260x208x4 = 216 KB sind zusammen 4,3 MiB — eine
       Speichergrenze wie im Hero braucht es dafuer nicht. (Bei step 4
       waeren es 40 und damit 8,6 MiB, auch das noch harmlos.) */
    function vorskalieren(img) {
      var cw = canvas.width, ch = canvas.height;
      if (!(cw > 0) || !(ch > 0)) return null;
      var q = zuschnitt(img);
      if (!(q.w > 0) || !(q.h > 0)) return null;
      if (cw * ch >= q.w * q.h * PRESCALE_RATIO) return null;
      var off, octx;
      try {
        off = document.createElement('canvas');
        off.width = cw;
        off.height = ch;
        octx = off.getContext('2d');
        if (!octx) return null;
        if (!malenAus(octx, img, cw, ch)) return null;
      } catch (e) {
        return null; /* kein Speicher, kein Kontext: dann eben direkt */
      }
      return off;
    }

    /* Eintragen, und NUR eintragen — vorskaliert wird ueber
       nachskalieren/nachPumpe(), Begruendung oben an der Zwischenstufe. */
    function uebernehmen(k, img) {
      quellen[k] = img;
      frames[k] = img;
      skaliert[k] = false;
      tabellen();
      nachskalieren.push(k);
      nachPlanen();
      /* Im Stillstand das Bild nachziehen: der neue Frame kann der
         passendere Nachbar sein. Laeuft die Schleife, macht sie das
         ohnehin im naechsten Bild. */
      if (!laeuft) zeichne();
    }
    /* Rueckgabe: true = eine Flaeche ist entstanden. Nur dann zaehlt der
       Vorgang in den Deckel von nachPumpe() — im Normalfall (kleine
       Fassung vom CDN) lohnt sich das Vorskalieren gar nicht und
       vorskalieren() liefert sofort null. */
    function nachtragen(k, img) {
      var off = vorskalieren(img);
      if (!off) return false;
      frames[k] = off;
      skaliert[k] = true;
      /* Nur neu malen, wenn dieser Platz gerade WIRKLICH auf der Flaeche
         steht — sonst waeren es nach einem Groessenwechsel bis zu n
         Zeichenvorgaenge fuer ein Bild, das sich nicht aendert. */
      if (k === aktuellLo || k === aktuellHi) {
        aktuellLo = -1;
        if (!laeuft) zeichne();
      }
      return true;
    }

    /* ---------- Fortschritt des ELEMENTS im Sichtfenster ----------
       0 = Oberkante erreicht gerade den unteren Bildschirmrand,
       1 = Element ist oben hinaus ODER das Seitenende ist erreicht.
       Das zweite ist der Grund fuer die Deckelung auf yMax: ein Fuss
       verlaesst das Bild nach oben praktisch nie, weil die Seite
       vorher aufhoert. Ohne die Deckelung bliebe die Drehung immer auf
       halbem Weg stehen.
       R15/P7, F7 — ALLE LAYOUT-LESEZUGRIFFE SIND HIER RAUS.
       Vorher las diese Funktion in JEDEM Bild getBoundingClientRect()
       UND documentElement.scrollHeight, und sie lief als Dauerschleife,
       solange der Fuss im Bild war — also auch im Stillstand. Jetzt wird
       gemessen, wenn sich etwas geaendert haben kann:
         - resize und orientationchange,
         - wenn der Fuss ins Bild kommt,
         - wenn sich die Hoehe von document.body aendert (ResizeObserver).
       Der letzte Punkt ist hier wichtiger als im Hero: der Fuss steht
       UNTER allem, jedes nachgeladene Bild weiter oben verschiebt ihn
       und aendert gleichzeitig scrollHeight. */
    var geoVeraltet = true;
    var gOben = 0, gHoehe = 0, gMax = 0, gVh = 800;
    function geoMessen() {
      var rect = root.getBoundingClientRect();
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var doc = document.documentElement;
      gVh = window.innerHeight || doc.clientHeight || 800;
      gOben = rect.top + y;
      gHoehe = rect.height;
      gMax = Math.max(0, (doc.scrollHeight || 0) - gVh);
      geoVeraltet = false;
    }
    function fortschritt() {
      if (geoVeraltet) geoMessen();
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      /* KEIN SCROLLWEG — und das muss VOR der Rechnung abgefangen
         werden. Die Pruefung unten greift dafuer nicht: steht das
         Element auf einer nicht scrollbaren Seite im Bild, ist
         b - a = vh - oben und damit positiv, p wird 1 und das Zeichen
         stuende auf dem LETZTEN Frame statt auf dem ersten. Gewollt
         ist Frame 0, also derselbe Stand wie das Standbild. */
      if (gMax < 1) return 0;
      var a = gOben - gVh;
      var b = Math.min(gOben + gHoehe, gMax);
      /* Rechenschutz: ohne Spanne keine Division. */
      if (b - a < 1) return 0;
      var p = (y - a) / (b - a);
      return p < 0 ? 0 : (p > 1 ? 1 : p);
    }

    var gemalt = false;
    /* Zustand der letzten Zeichnung: die beiden gemalten Plaetze und das
       Mischverhaeltnis in 1/64. aktuellLo < 0 heisst "noch nichts". */
    var aktuellLo = -1, aktuellHi = -1, aktuellF = -1;

    /* Die Flaechengroesse wird NICHT in jedem Bild nachgemessen.
       clientWidth/clientHeight sind Layout-Lesezugriffe; in einer
       rAF-Schleife erzwingen sie 60-mal in der Sekunde eine Neuberechnung
       des Layouts, und zwar fuer nichts — die Groesse aendert sich nur
       beim Umdimensionieren des Fensters. Das Flag sagt, wann wirklich
       gemessen werden muss. */
    var messenNoetig = true;

    function flaecheStimmt() {
      if (!messenNoetig && canvas.width > 0) return true;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = Math.round((canvas.clientWidth || 0) * dpr);
      var h = Math.round((canvas.clientHeight || 0) * dpr);
      if (w <= 0 || h <= 0) return false; /* Layout noch nicht da: beim naechsten Bild erneut */
      messenNoetig = false;
      if (Math.abs(canvas.width - w) > 1 || Math.abs(canvas.height - h) > 1) {
        canvas.width = w;
        canvas.height = h;
        aktuellLo = -1; /* nach dem Umdimensionieren ist die Flaeche leer */
        /* Vorskalierte Flaechen haben jetzt die falsche Groesse. Sie
           fallen auf ihre Quelle zurueck — sofort sichtbar weiter, nur
           wieder mit Resampling — und werden nebenlaeufig neu erzeugt.
           Nichts wird verworfen, es blitzt also kein Standbild
           dazwischen. Mitgeprueft werden auch die nicht vorskalierten:
           nach einem Groessenwechsel kann sich die Regel umdrehen (eine
           kleinere Box bei gleichbleibend grosser Quelle). Wo es sich
           nicht lohnt, kostet die Pruefung nichts. */
        var neu = false;
        nachskalieren.length = 0;
        for (var k = 0; k < n; k++) {
          if (skaliert[k]) {
            skaliert[k] = false;
            if (quellen[k]) { frames[k] = quellen[k]; neu = true; }
            else { frames[k] = null; neu = true; }
          }
          if (quellen[k]) nachskalieren.push(k);
        }
        if (neu) tabellen();
        nachPlanen();
      }
      return true;
    }

    /* ---------- Malen: ueberblenden statt rasten ----------
       Gesucht sind die beiden geladenen Nachbarn unter und ueber
       `gezeigt`. Der untere wird voll gemalt, der obere mit Alpha f
       darueber. Nur bis BLEND_MAX FRAMES Abstand — ein Platz ist step
       Frames weit.
       BEIM HEUTIGEN step 8 sind das 18 Grad, die Grenze greift also immer
       und es wird GERASTET, nicht ueberblendet: zwei Zeichen im Abstand
       von 18 Grad liest das Auge als Doppelbelichtung, nicht als
       Bewegung. Die Ueberblendung steht hier trotzdem, vollstaendig und
       geprueft — bei step 4 (9 Grad, genau die Grenze) schaltet sie sich
       von selbst ein. Warum step heute 8 ist, steht oben bei CROP_*: der
       Zuschnitt ist ueber genau diese 20 Frames gemessen.
       Weich ist die Drehung im Fuss deshalb nicht ueber die Ueberblendung,
       sondern ueber die zeitbasierte Glaettung in tick() (F5) — die gab es
       hier vorher gar nicht. */
    function zeichne() {
      if (!flaecheStimmt()) return;
      var cw = canvas.width, ch = canvas.height;
      if (cw <= 0 || ch <= 0) return;
      if (gezeigt < 0) gezeigt = fortschritt() * (n - 1);
      var t = gezeigt;
      if (t < 0) t = 0;
      if (t > n - 1) t = n - 1;

      var lo = vorh[Math.floor(t)];
      var hi = nach[Math.ceil(t)];
      if (lo < 0 && hi < 0) return; /* noch kein Frame: Standbild bleibt */
      var f = 0;
      if (lo < 0) {
        lo = hi;
      } else if (hi < 0) {
        hi = lo;
      } else if (hi !== lo) {
        if ((hi - lo) * step > BLEND_MAX) {
          if ((t - lo) <= (hi - t)) hi = lo; else lo = hi;
        } else {
          f = (t - lo) / (hi - lo);
          if (f <= 0.004) { hi = lo; f = 0; }
          else if (f >= 0.996) { lo = hi; f = 0; }
        }
      }

      var fq = Math.round(f * 64);
      if (lo === aktuellLo && hi === aktuellHi && fq === aktuellF) return;

      var a = frames[lo];
      var b = (hi !== lo && fq > 0) ? frames[hi] : null;
      /* Fehlt die Hauptquelle, wird NICHT geleert: dann bleibt lieber
         das letzte Bild stehen, als dass die Flaeche leer wird, waehrend
         is-live schon gesetzt ist. */
      if (!a) return;

      /* clearRect ist TRAGEND: die Frames haben einen Alphakanal.
         cw/ch sind die Geraetepunkte einschliesslich
         devicePixelRatio — auf ctx liegt keine Transformation, es wird
         also wirklich die ganze Flaeche geleert. Beim Ueberblenden gilt
         das doppelt. */
      ctx.clearRect(0, 0, cw, ch);
      blit(a, skaliert[lo], 1, cw, ch);
      if (b) blit(b, skaliert[hi], f, cw, ch);

      aktuellLo = lo;
      aktuellHi = hi;
      aktuellF = fq;

      if (!gemalt) {
        gemalt = true;
        root.classList.add('is-live');
      }
    }

    function blit(src, istSkaliert, alpha, cw, ch) {
      if (alpha !== 1) ctx.globalAlpha = alpha;
      /* Eine vorskalierte Flaeche in genau der Zeichenflaechengroesse ist
         ein 1:1-Blit ohne Zuschnitt und ohne Resampling. */
      if (istSkaliert && src.width === cw && src.height === ch) {
        ctx.drawImage(src, 0, 0);
      } else {
        malenAus(ctx, src, cw, ch);
      }
      if (alpha !== 1) ctx.globalAlpha = 1;
    }

    /* ---------- Die Schleife laeuft nur bei Bewegung ----------
       R15/P7, F7: vorher kettete sich tick() selbst, solange der Fuss im
       Bild war (IntersectionObserver mit 200px Rand) — eine rAF-Schleife
       also auch dann, wenn niemand scrollte, und jedes Bild mit zwei
       erzwungenen Layouts. Jetzt wird die Schleife beim Scrollen
       angestossen und laeuft, bis die Glaettung angekommen ist. Der
       Beobachter bleibt der Schalter fuer das LADEN und dafuer, ob ein
       Scroll ueberhaupt etwas anstoesst.
       R15/P7, F5: der Fuss hatte GAR KEINE Glaettung — zeichne() folgte
       fortschritt() direkt und war bei Trackpad-Spruengen hart. Jetzt
       dieselbe zeitbasierte Glaettung wie oben, mit demselben TAU, damit
       sich oben und unten gleich anfuehlen. */
    var imBild = false;
    var laeuft = false;
    var gezeigt = -1;
    var letztTs = 0;

    function tick(ts) {
      if (typeof ts !== 'number') {
        ts = (window.performance && window.performance.now) ? window.performance.now() : Date.now();
      }
      var dt = letztTs ? (ts - letztTs) : 16.7;
      if (!(dt > 0)) dt = 0;
      if (dt > MAX_DT) dt = MAX_DT;
      letztTs = ts;

      var ziel = fortschritt() * (n - 1);
      if (gezeigt < 0) gezeigt = ziel;
      gezeigt += (ziel - gezeigt) * (1 - Math.exp(-dt / TAU));
      /* Schluss in FRAMES gerechnet, damit oben und unten dieselbe
         Schwelle haben: ENDE Frames geteilt durch step Frames je Platz. */
      if (Math.abs(ziel - gezeigt) < (ENDE / step)) {
        gezeigt = ziel;
        laeuft = false;
      }
      zeichne();
      if (laeuft) {
        window.requestAnimationFrame(tick);
      } else {
        letztTs = 0;
      }
    }

    function anstossen() {
      if (laeuft) return;
      laeuft = true;
      letztTs = 0;
      window.requestAnimationFrame(tick);
    }

    function starten() {
      imBild = true;
      geoVeraltet = true;
      if (stufe === 0) {
        stufe = 1;
        /* Jetzt steht das Layout, jetzt ist die Groesse verlaesslich. */
        flaecheStimmt();
        groesse = variante();
        /* Stufe 1: jeder zweite Eintrag der Liste. */
        einreihen(2);
        pumpe();
      }
      /* Einmal zeichnen, damit beim Sichtwerden der richtige Frame steht
         — ohne Dauerschleife. */
      anstossen();
    }

    function anhalten() {
      imBild = false;
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (eintraege) {
        for (var e = 0; e < eintraege.length; e++) {
          if (eintraege[e].isIntersecting) starten();
          else anhalten();
        }
      }, { rootMargin: '200px 0px' });
      io.observe(root);
    } else {
      /* Ohne Beobachter wird am scroll-Ereignis nachgezogen. Keine
         Dauerschleife — die gab es auch vorher hier nicht. */
      starten();
    }

    /* Das Scrollen ist die einzige Quelle von Bewegung: es stoesst die
       Schleife an und reicht Stufe 2 nach (F8). Beides nur, wenn der
       Fuss ueberhaupt im Bild ist. */
    window.addEventListener('scroll', function () {
      if (!imBild) return;
      verfeinern();
      anstossen();
    }, { passive: true });

    function neuMessen() {
      aktuellLo = -1;
      messenNoetig = true;
      geoVeraltet = true;
      var g = variante();
      /* Wird eine groessere Fassung gebraucht, als geladen wurde, wird
         NICHT alles neu geholt — die vorhandenen Bilder werden nur
         hochskaliert gezeichnet. Ein Fenster, das waehrend des Besuchs
         breiter wird, ist den zweiten Download nicht wert. */
      if (g > groesse) groesse = g;
      anstossen();
    }
    /* NICHT ENTPRELLT, anders als der resize-Weg im Hero — und das ist
       Absicht, nicht Vergessen. Was hier je Ereignis anfaellt, ist eine
       Layout-Lesung in variante() plus hoechstens SCALE_BURST (2)
       Vorskalierungen von 260x208 Punkten, und auch die nur im
       Rueckfall auf die 1560er Originale. Im Hero waren es bis zu 31
       Flaechen von 1800x451 je Ereignis, dort tragen die 150 ms. Hier
       waere Entprellen nur eine Verzoegerung: die Zeichnung stuende 150 ms
       gedehnt im neuen Kasten, ohne dass etwas gespart wird. */
    window.addEventListener('resize', neuMessen, { passive: true });
    window.addEventListener('orientationchange', neuMessen, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      /* Jedes nachgeladene Bild weiter oben in der Seite verschiebt den
         Fuss und aendert scrollHeight. Beobachtet wird deshalb die Hoehe
         von body, nicht die der Zeichenflaeche. */
      new ResizeObserver(function () {
        geoVeraltet = true;
        if (imBild) anstossen();
      }).observe(document.body);
    }

    /* Das Poster kann fehlschlagen (geloeschtes Asset). Dann ist die
       Zeichenflaeche die einzige Chance auf ein Bild — sie wird sofort
       sichtbar gemacht, damit nicht beides fehlt. */
    if (poster) {
      poster.addEventListener('error', function () {
        root.classList.add('is-live');
      });
    }
  }

  function initAll() {
    var alle = document.querySelectorAll('[data-byg-footer-logo]');
    for (var i = 0; i < alle.length; i++) initOne(alle[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme-Editor: Section wird neu gerendert → neu initialisieren. */
  document.addEventListener('shopify:section:load', initAll);
})();
